/**
 * Escapes HTML special characters to prevent XSS when rendering untrusted text.
 * This should be used when passing user-generated or AI-generated content to components
 * that render HTML (like UnsafeHTMLText).
 */
export function escapeHtml(text: string): string {
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}
